import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const updateUserRoles = async ({ userId, roles }: { userId: string; roles: string[] }) => {
  const response = await mutationExecute({
    variables: {
      userId,
      roles,
    },
    mutation: graphql(`
      mutation UpdateUserRoles($userId: String!, $roles: [String!]!) {
        updateUserRoles(userId: $userId, roles: $roles) {
          id
        }
      }
    `),
  });

  return response.data?.updateUserRoles;
};
